import axios from 'axios'
import { API_URL, DOMAIN } from '../../constants'
import router from './../../router'
const LOGIN = 'LOGIN'
const SIGN_UP = 'SIGN_UP'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const state = {
  showModal: false,
  isLoggedIn: !!localStorage.getItem('token'),
  token: localStorage.getItem('token'),
  loginError: null,
  user: JSON.parse(localStorage.getItem('user')),
  dashboardData: {
    business: {},
    membersWhoFollow: [],
    purchasesTracked: [],
    outstandingRewards: [],
    announcements: [],
  },
  agent: JSON.parse(localStorage.getItem('agent')),
}

if (state.token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`
}

// getters
const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  getUser: state => {
    return state.user
  },
}

// actions
const actions = {
  login ({ commit, dispatch }, credentials) {
    axios.post(
      `${API_URL}/api/v3/business/login`,
      credentials
    ).then(response => {
      if (response.data.data.token) {
        state.newDataUser = response.data.data.user
        if (state.newDataUser.business.slug) {
          const subdomain = state.newDataUser.business.slug + DOMAIN
          if (window.location.hostname !== subdomain) {
            window.location.href = 'http://' + subdomain
            return
          }
        }

        commit(
          LOGIN_SUCCESS,
          {
            token: response.data.data.token,
            user: response.data.data.user,
            agent: response.data.data.agent,
          }
        )
        router.push({name: 'Dashboard'})
      }
    }).catch((error) => {
      alert(error.response.data.error.message)
    })
  },
  signUp ({ commit, dispatch }, credentials) {
    axios.post(
      `${API_URL}/api/v3/business`,
      credentials
    ).then(response => {
      if (response.data.data.token) {
        commit(
          LOGIN_SUCCESS,
          {
            // token: response.data.data.token,
            user: response.data.data.user
          }
        )

        // router.push({ name: 'Dashboard' })
      }
    }).catch((error) => {
      alert(error.response.data.error.message)
    })
  },
  logout ({ commit }) {
    commit(LOGOUT)
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    router.push({ name: 'Login' })
  },
  async getDashboardData ({ commit, state }) {
    const response = await axios.get(`${API_URL}/api/v3/business/${state.user.id}/stats`, {
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    })
    if (response.data.success) {
      commit('setDashboardData', response.data.data)
    }
  },
}

// mutations
const mutations = {
  [LOGIN] (state) {
    state.pending = true
  },
  [SIGN_UP] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state, { token, user, agent }) {
    if (token) {
      localStorage.setItem('token', token)
      state.isLoggedIn = true
      localStorage.setItem('user', JSON.stringify(user))
      if (agent) {
        localStorage.setItem('agent', JSON.stringify(agent))
      }
    }
    state.pending = false
    state.token = token
    state.user = user
    state.agent = agent

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
    localStorage.removeItem('user')
    localStorage.removeItem('agent')
    localStorage.removeItem('token')
    state.agent = null
    state.user = null
    state.token = null
    axios.defaults.headers.common['Authorization'] = null
  },
  setDashboardData (state, data) {
    state.dashboardData = data
  },
  onAddressChange (state, {field, value}) {
    state.dashboardData.business[field] = value
  },
  accountChanges (state, {field, value}) {
    state.newDataUser[field] = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js